module.exports = __webpack_public_path__ + "img/Plantilla_OT.bdb56a14.jpg";